import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import EditIcon from '@mui/icons-material/Edit';
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { Add, Delete, Replay, Save } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';
import ReplayIcon from '@mui/icons-material/Replay';

export const AgregarModelosScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const idPromocion = state?.idpromocion;
    const promocion = state?.promocion;
    // const lineaSeleccionada = state?.linea;
    const [modelos, setModelos] = useState([]);
    const [lineaSeleccionada, setLineaSeleccionada] = useState(1);
    const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(1);
    const [lineasDisponibles, setLineasDisponibles] = useState([]);
    const [preciosEditados, setPreciosEditados] = useState({});
    const [modelosValidos, setModelosValidos] = useState([]);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    function removeCommas(value) {
        return value.replace(/,/g, '');
    }

    const handleLineaChange = (event) => {
        const idLinea = event.target.value;
        setLineaSeleccionada(idLinea);

        const linea = lineasDisponibles.find(l => l.idlinea === idLinea);
        setDepartamentoSeleccionado(linea ? linea.iddepartamento : null);
    };

    const handlePrecioChange = (idmodelo, idpromocion, field, valor) => {
        const numericValue = parseFloat(removeCommas(valor)) || 0;

        const prev = preciosEditados[idmodelo] || {
            idmodelo,
            idpromocion,
            costo_refacciones: 0,
            costo_servicios: 0,
            precio_promocion: 0,
        };

        let updated = { ...prev, [field]: numericValue };

        // 👈 Si es departamento 3, calculamos precio_promocion automáticamente
        if (departamentoSeleccionado === 3) {
            updated.precio_promocion =
                (updated.costo_refacciones || 0) + (updated.costo_servicios || 0);
        }

        const nuevosPrecios = { ...preciosEditados, [idmodelo]: updated };
        setPreciosEditados(nuevosPrecios);

        // Solo los válidos (> 0)
        const validos = Object.values(nuevosPrecios).filter(
            (m) => m.precio_promocion > 0
        );
        setModelosValidos(validos);
    };


    useEffect(() => {
        onExecute();
    }, []);

    const onExecute = () => {
        const fetchData = async () => {
            setLoader(prev => ({ ...prev, mostrar: true }));

            try {
                const requests = [
                    request.get(`PromocionesDisponibles/ObtenerModelosEsquema?idpromocion=${idPromocion}`),
                    request.get(`ListadoModelos/LineasDropDownList`)
                ];

                const [result1, result2] = await Promise.all(requests);

                setModelos(result1);
                setLineasDisponibles(result2);
            } catch (error) {
                Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
            } finally {
                setLoader(prev => ({ ...prev, mostrar: false }));
            }
        };
        fetchData();
    };

    const onEliminar = (idmodelo, idpromocion) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "Esta acción eliminará el modelo del esquema.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoader({ ...loader, mostrar: true });

                request
                    .get(`PromocionesDisponibles/EliminarModelosdeEsquema?idmodelo=${idmodelo}&idpromocion=${idpromocion}`)
                    .then(() => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("Éxito", "Datos actualizados correctamente", "success");
                        onExecute();
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("Error", JSON.stringify(error), "error");
                    });
            }
        });
    };

    const onRestaurar = (idmodelo, idpromocion) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "Esta acción restaurará el modelo en el esquema.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoader({ ...loader, mostrar: true });

                request
                    .get(`PromocionesDisponibles/RestaurarModelosdeEsquema?idmodelo=${idmodelo}&idpromocion=${idpromocion}`)
                    .then(() => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("Éxito", "Datos actualizados correctamente", "success");
                        onExecute();
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("Error", JSON.stringify(error), "error");
                    });
            }
        });
    };


    const onGuardar = () => {
        if (!modelosValidos || modelosValidos.length === 0) {
            Swal.fire("Atención", "No se han seleccionado modelos para agregar al esquema.", "warning");
            return;
        }

        const post = { modelosEsquema: modelosValidos };

        // console.log(post)

        setLoader({ ...loader, mostrar: true });

        request
            .post("PromocionesDisponibles/GuardarModelosEsquema", post)
            .then(() => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Éxito", "Datos actualizados correctamente", "success");
                setModelosValidos([]);
                setPreciosEditados({});
                onExecute();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Error", JSON.stringify(error), "error");
            });
    };

    // console.log(modelosValidos)
    return (
        <PlantillaScreen
            titulo={`REGISTRO DE MODELOS EN LISTA DE PRECIOS DE ${promocion.toUpperCase()}`}
            className={"agregar-modelo-esquema-main-screen"}
            className_main={1}
        >
            <div className="agregar-modelo-esquema-actions">
                <div
                    className="agregar-modelo-esquema-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
            <div className="agregar-modelo-esquema">
                <div className="agregar-modelo-esquema-filtro">
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel id="linea-select-label">Mostrar Línea</InputLabel>
                        <Select
                            labelId="linea-select-label"
                            value={lineaSeleccionada}
                            label="Filtrar por Línea"
                            onChange={handleLineaChange}
                        >
                            {lineasDisponibles.map((linea, index) => (
                                <MenuItem key={linea.idlinea} value={linea.idlinea}>
                                    {capitalizePalabras(linea.descripcion)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <LoaderScreen loader={loader} />
                <div className="agregar-modelo-esquema-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Línea
                                </th>
                                <th>
                                    <div>Modelo</div>
                                </th>
                                <th>
                                    <div>Descripcion</div>
                                </th>
                                {/* <th>
                                    <div>Esquema de pago</div>
                                </th> */}
                                <th>
                                    <div>Precio Normal</div>
                                </th>
                                {departamentoSeleccionado === 3 && (
                                    <>
                                        <th><div>Costo de refacciones</div></th>
                                        <th><div>Costo de servicio</div></th>
                                    </>
                                )}
                                <th>
                                    <div>Precio oferta</div>
                                </th>
                                <th>
                                    <div style={{ color: 'transparent' }}>.</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {modelos
                                .filter((mo) => !lineaSeleccionada || mo.idlinea === lineaSeleccionada)
                                .map((mo) => (
                                    <tr key={mo.idmodelo} style={{ color: mo.eliminado === 'S' ? 'red' : 'inherit' }}>
                                        <td className="celda-modelo">
                                            <div>{mo.linea}</div>
                                        </td>
                                        <td className="celda-modelo">{mo.modelo}</td>
                                        <td className="celda-descripcion">{mo.descripcion}</td>
                                        <td className="celda-importe">{FormatMoney(mo.precio_lista)}</td>
                                        {departamentoSeleccionado === 3 && (
                                            <>
                                                {/* Inputs para costos */}
                                                <td className="celda-importe">
                                                    <input
                                                        type="text"
                                                        inputMode="decimal"
                                                        disabled={mo.eliminado === "S"}
                                                        value={formatWithCommas(
                                                            preciosEditados[mo.idmodelo]?.costo_refacciones ?? mo.costo_refacciones ?? 0
                                                        )}
                                                        onChange={(e) =>
                                                            handlePrecioChange(
                                                                mo.idmodelo,
                                                                idPromocion,
                                                                "costo_refacciones",
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            width: "100px",
                                                            textAlign: "right",
                                                            border: "none",
                                                            backgroundColor: "transparent",
                                                            color: mo.eliminado === "S" ? "red" : "inherit",
                                                        }}
                                                    />
                                                </td>

                                                <td className="celda-importe">
                                                    <input
                                                        type="text"
                                                        inputMode="decimal"
                                                        disabled={mo.eliminado === "S"}
                                                        value={formatWithCommas(
                                                            preciosEditados[mo.idmodelo]?.costo_servicios ?? mo.costo_servicios ?? 0
                                                        )}
                                                        onChange={(e) =>
                                                            handlePrecioChange(
                                                                mo.idmodelo,
                                                                idPromocion,
                                                                "costo_servicios",
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            width: "100px",
                                                            textAlign: "right",
                                                            border: "none",
                                                            backgroundColor: "transparent",
                                                            color: mo.eliminado === "S" ? "red" : "inherit",
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )}
                                        <td className="celda-importe">
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                disabled={departamentoSeleccionado === 3 || mo.eliminado === 'S'} // 👈 deshabilitado si es dep 3 o eliminado
                                                value={formatWithCommas(
                                                    departamentoSeleccionado === 3
                                                        ? (preciosEditados[mo.idmodelo]?.costo_refacciones ?? mo.costo_refacciones ?? 0) +
                                                        (preciosEditados[mo.idmodelo]?.costo_servicios ?? mo.costo_servicios ?? 0)
                                                        : preciosEditados[mo.idmodelo]?.precio_promocion ?? mo.precio_promocion
                                                )}
                                                onChange={(e) =>
                                                    departamentoSeleccionado !== 3 && // 👈 solo editable si NO es dep 3
                                                    handlePrecioChange(
                                                        mo.idmodelo,
                                                        idPromocion,
                                                        "precio_promocion",
                                                        e.target.value
                                                    )
                                                }
                                                style={{
                                                    width: "100px",
                                                    padding: "4px",
                                                    backgroundColor: "transparent",
                                                    border: "none",
                                                    textAlign: "right",
                                                    MozAppearance: "textfield",
                                                    appearance: "textfield",
                                                    color: mo.eliminado === 'S' ? 'red' : 'inherit',
                                                    cursor:
                                                        departamentoSeleccionado === 3 || mo.eliminado === 'S'
                                                            ? ''
                                                            : 'text'
                                                }}
                                            />
                                        </td>

                                        <td className="celda-eliminar">
                                            {mo.eliminado !== 'S' ? (
                                                <div className="boton-eliminar" onClick={() => onEliminar(mo.idmodelo, idPromocion)}>
                                                    <Delete /> Eliminar
                                                </div>
                                            ) : (
                                                <div className="boton-restaurar" onClick={() => onRestaurar(mo.idmodelo, idPromocion)}>
                                                    <Replay /> Restaurar
                                                </div>
                                            )}
                                        </td>
                                    </tr>

                                ))}
                        </tbody>
                    </table>
                </div>
                <div className="buttons">
                    <div
                        className="agregar-modelo-esquema"
                        onClick={() => onGuardar()}
                    >
                        <Save /> Guardar
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
